import React from "react";
import { Alert } from "antd";
import styles from "./access-restricted-alert.css";
import { WarningOutlined } from "@ant-design/icons";

const { ["alert-container"]: alertContainerClassName } = styles;

type AccessRestrictedAlertProps = {
  description?: React.ReactNode;
};

export const AccessRestrictedAlert = ({
  description = "Sorry! You do not have permission to access this section.",
}: AccessRestrictedAlertProps) => {
  return (
    <div className={alertContainerClassName}>
      <Alert
        style={{ marginTop: 16 }}
        message="Restricted Access"
        description={description}
        type="warning"
        icon={<WarningOutlined />}
        showIcon
        banner
      />
    </div>
  );
};
